import { useState } from "react";
import { toast } from "sonner";
import { Image as ImageIcon, Video, FileText, X, Loader2, Upload } from "lucide-react";
import { api, apiErr, fileUrl } from "../api";

/** Subida de archivos (EKG, eco, laboratorios). onChange recibe la lista nueva de referencias. */
export default function MediaField({ label, media = [], onChange, accept = "image/*", hint }) {
  const [busy, setBusy] = useState(false);
  const Icon = accept.includes("pdf") ? FileText : accept.includes("video") ? Video : ImageIcon;

  const upload = async (e) => {
    const files = Array.from(e.target.files || []);
    e.target.value = "";
    if (!files.length) return;
    setBusy(true);
    let list = [...media];
    for (const f of files) {
      const fd = new FormData();
      fd.append("file", f);
      try {
        const { data } = await api.post("/upload", fd);
        list = [...list, data];
      } catch (err) {
        toast.error(`${f.name}: ${apiErr(err, "no se pudo subir")}`);
      }
    }
    setBusy(false);
    if (list.length !== media.length) await onChange(list);
  };

  return (
    <div className="sm:col-span-2">
      <label className="pn-label">{label}</label>
      <div className="flex flex-wrap gap-3">
        {media.map((m, i) => (
          <div key={m.path + i} className="relative group w-24 h-24 rounded-xl overflow-hidden pn-card2 border pn-line flex items-center justify-center">
            <a href={fileUrl(m.path)} target="_blank" rel="noreferrer" title={m.filename} className="w-full h-full flex flex-col items-center justify-center gap-1 p-1">
              {m.type === "image" ? (
                <img src={fileUrl(m.path)} alt={m.filename || "imagen"} className="w-full h-full object-cover" />
              ) : (
                <>
                  {m.type === "video" ? <Video size={22} className="pn-accent" /> : <FileText size={22} className="pn-brand" />}
                  <span className="text-[10px] pn-sub w-full truncate text-center">{m.filename}</span>
                </>
              )}
            </a>
            <button type="button" onClick={() => onChange(media.filter((_, j) => j !== i))} aria-label="Quitar archivo"
              className="absolute top-1 right-1 bg-black/60 hover:bg-red-600 text-white rounded-full p-1 transition"><X size={11} /></button>
          </div>
        ))}
        <label className={`w-24 h-24 rounded-xl border-2 border-dashed pn-line flex flex-col items-center justify-center gap-1 pn-muted transition ${busy ? "opacity-60" : "cursor-pointer hover:pn-accent"}`}>
          {busy ? <Loader2 size={20} className="pn-spin" /> : <Icon size={20} />}
          <span className="text-[11px] flex items-center gap-1">{busy ? "Subiendo…" : <><Upload size={11} /> Subir</>}</span>
          <input type="file" accept={accept} multiple className="hidden" onChange={upload} disabled={busy} />
        </label>
      </div>
      {hint && <p className="text-[11px] pn-muted mt-1.5">{hint}</p>}
    </div>
  );
}
